import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/auth/redirect";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function AuthCallback() {
  const location = useLocation();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState({}, "", "/");
        const dest = !data.role || !data.has_consent
          ? "/choose-role"
          : data.role === "admin"
          ? "/admin"
          : data.role === "pharmacy"
          ? data.has_profile
            ? "/pharmacy"
            : "/pharmacy/onboarding"
          : data.has_profile
          ? "/worker"
          : "/worker/onboarding";
        window.location.replace(dest);
      } catch (e) {
        setError("Google sign-in failed. Please try again.");
      }
    })();
  }, [location.hash]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      {error ? (
        <div className="text-center">
          <p className="text-slate-700">{error}</p>
          <a href="/login" className="btn-primary mt-4">
            Back to sign in
          </a>
        </div>
      ) : (
        <Loader2 className="h-6 w-6 animate-spin text-brand" />
      )}
    </div>
  );
}
